import React, { createContext, useContext } from 'react';
import type { GuestStay } from '@shared/components/GuestStayAvatars/GuestStayAvatars.types';

export type { GuestStay };

/** joyPlaceId -> the guests known to be staying there. */
export type GuestStaysByPlace = ReadonlyMap<string, ReadonlyArray<GuestStay>>;

const EMPTY_BY_PLACE: GuestStaysByPlace = new Map();
const EMPTY_STAYS: ReadonlyArray<GuestStay> = [];

const GuestStaysContext = createContext<GuestStaysByPlace>(EMPTY_BY_PLACE);

/**
 * Guests booked into a given place, for map markers.
 *
 * Defaults to empty instead of throwing, unlike the sibling map/list sync context: this console
 * is shared with the guest-facing hotel search, which has no booking data and never mounts the
 * provider. Only the admin Explore Area supplies it, so guest surfaces render unchanged.
 */
export const useGuestStaysForPlace = (joyPlaceId: string | null | undefined): ReadonlyArray<GuestStay> => {
  const staysByPlace = useContext(GuestStaysContext);
  if (!joyPlaceId) return EMPTY_STAYS;
  return staysByPlace.get(joyPlaceId) ?? EMPTY_STAYS;
};

type GuestStaysProviderProps = Readonly<{
  value: GuestStaysByPlace;
  children: React.ReactNode;
}>;

export const GuestStaysProvider: React.FC<GuestStaysProviderProps> = ({ value, children }) => <GuestStaysContext.Provider value={value}>{children}</GuestStaysContext.Provider>;
